import React, { Component } from "react";
import { Icon, Button, Modal, Table, Form, Input, Checkbox, message, Tooltip } from 'antd';
import { roleMenuList, roleInfoSelect } from '@/request/api'
import {requestErrorLog } from '@/common/util'

const { TextArea } = Input;
const { confirm } = Modal;


class SettingRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      powerMenuList: [],
      checked: true,
      rowData: "",
      roleCode: "",
      roleName: "",
      tableList: [],
      PageNo: 1,
      PageSise: 10,
      RowCount: 0,
      roleColumns: [
        {
          title: "角色编码",
          dataIndex: "ROLE_CODE",
          key: "ROLE_CODE",
          width: 320,
        },
        {
          title: "角色名称",
          dataIndex: "ROLE_NAME",
          key: "ROLE_NAME",
          width: 120
        },
        {
          title: "角色权限",
          dataIndex: "PRIVILEGE",
          key: "PRIVILEGE",
          align: 'center',
          width: 160,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: "有效",
          dataIndex: "IS_ENABLED",
          key: "IS_ENABLED",
          width: 120,
          render: (text) => {
            return text ? "是" : "否";
          },
        },
        {
          title: "描述",
          dataIndex: "ROLE_REMARKS",
          key: "ROLE_REMARKS",
        },
      ],
    };
  }

  componentDidMount() {
    this.handleRoleList()
    this.permissionList()
  }

  permissionList = () => { // 角色权限列表
    roleMenuList().then((res) => {
      if (res && res.Status === 1) {
        const RoleList = res.Result.RoleList
        let powerMenuList = [];
        RoleList.forEach(item => {
          powerMenuList.push({ label: item.PRIVILEGE_NAME, value: item.PRIVILEGE_UID })
        })
        this.setState({
          powerMenuList,
        })
      }else{
        requestErrorLog('', '权限管理-角色管理-获取角色权限列表报错', 0, true)
      }
    })
  }

  handleRoleList = () => { // 角色列表 
    this.props.form.validateFields((values) => {
      let params = {
        Type: "ROLE_INFOSELECT",
        // "HOSPITAL_CODE": userInfo.HOSPITAL_CODE,
        ROLE_CODE: this.state.roleCode,
        ROLE_NAME: this.state.roleName,
        PageNo: this.state.PageNo,
        PageSize: this.state.PageSise
      }
      roleInfoSelect(params).then((res) => {
        if (res && res.Status === 1) {
          const dataList = res.Result.dataInfo
          let RowCount = res.Result.pageInfo.RowCount
          this.setState({
            tableList: dataList,
            RowCount
          })
        }else{
          requestErrorLog('', '权限管理-角色管理-获取角色列表报错', 0, true)
        }
      })
    })
  }

  handleRoleAdd = () => { // 新增
    this.props.form.resetFields(); //清空form中每条数据
    this.setState({
      isModalVisible: true,
      modalTitle: "ROLE_ADD",
      rowData: "",
      checked: true,
    });
  };

  handleRoleEdit = () => {//修改
    this.props.form.resetFields();
    const { rowData } = this.state
    let privilegeId = [];//角色信息
    if (rowData) {
      if (rowData.PRIVILEGE_UID && !Array.isArray(rowData.PRIVILEGE_UID)) {
        rowData.PRIVILEGE_UID = rowData.PRIVILEGE_UID.split(',')
      }
      if (rowData.PRIVILEGE_UID) {
        privilegeId = rowData.PRIVILEGE_UID.map((item) => {
          return { PRIVILEGE_UID: item }
        })
      }
      this.setState({
        isModalVisible: true,
        modalTitle: "ROLE_EDIT",
        rowData,
        powerMenu: privilegeId,
        checked: rowData.IS_ENABLED
      });
    } else {
      message.warning('请先选择要操作的数据');
    }
  };

  handleRoleDelete = () => { // 删除
    const { rowData } = this.state
    if (!rowData) {
      message.warning('请先选择要操作的数据');
    } else {
      confirm({
        title: '删除操作',
        content: '确认删除该角色吗？',
        onOk: () => {
          let params = {
            Type: "ROLE_INFODELETE",
            ROLE_UID: rowData.ROLE_UID
          }
          roleInfoSelect(params).then((res) => {
            if (res && res.Status === 1) {
              message.success("删除成功！")
              this.handleRoleList()
              this.setState({ rowData: '' })
            } else {
              requestErrorLog('', '权限管理-角色管理-删除角色报错', 0, true)
              message.error("删除失败！")
            }
          })
        },
      });
    }
  };

  handleRoleSubmit = () => {
    const { modalTitle, rowData, checked, powerMenu } = this.state
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let Param = {
          Type: modalTitle,
          HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        }
        let RequestModel = {
          roleinfo: {
            ROLE_UID: modalTitle === 'ROLE_EDIT' ? rowData.ROLE_UID : '',
            ROLE_CODE: values.ROLE_CODE,  // 角色编码
            ROLE_NAME: values.ROLE_NAME,  // 角色名称
            ROLE_REMARKS: values.ROLE_REMARKS,  // 角色备注
            IS_ENABLED: checked ? 1 : 0
          },
          role_Privilege: powerMenu || [],
        }
        roleInfoSelect(Param, RequestModel).then((res) => {
          if (res && res.Status === 1) {
            if (res.Result === -2) {
              message.error('角色名称不能相同')
              return;
            }
            this.setState({ isModalVisible: false, rowData: '', powerMenu: [] })
            this.handleRoleList()
            modalTitle === 'ROLE_ADD' ? message.success("新建成功！") : message.success("修改成功！")
          } else {
            requestErrorLog('', '权限管理-角色管理-' + modalTitle === 'ROLE_ADD' ? '新建角色报错' : '编辑角色报错', 0, true)
            modalTitle === 'ROLE_ADD' ? message.error("新建失败！") : message.error("修改失败！")
          }
        });
      }
    })
  }

  onClickRow = (record) => {
    return {
      onClick: () => {
        this.setState({
          rowData: record,
        });
      },
    };
  };

  setRowClassName = (record) => {
    return record === this.state.rowData ? "clickRowStyl" : "";
  };

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
      checked: true,
      powerMenu: [],
    });
  };

  onAddCheckbox = (value) => {
    this.setState({
      checked: value.target.checked
    })
  }

  handleRoleName = (e) => {
    this.setState({
      roleName: e.target.value
    })
  }
  handleRoleCode = (e) => {
    this.setState({
      roleCode: e.target.value
    })
  }

  handleRoleValue = (checkedValues) => { // 角色权限
    const { powerMenuList } = this.state;
    const PowerMenu = []
    powerMenuList.forEach(item => {
      if (checkedValues.indexOf(item.value) > -1) {
        PowerMenu.push({ "PRIVILEGE_UID": item.value })
      }
    })
    this.setState({
      powerMenu: PowerMenu
    })
  }

  changePageFn = (PageNo) => {
    this.setState({
      PageNo
    }, () => {
      this.handleRoleList()
    })
  }

  searchRoleFn = () => {
    this.setState({
      PageNo: 1,
      PageSize: 10,
    }, () => {
      this.handleRoleList()
    })
  }

  onKeyUpFn = e => {
    if (e.keyCode === 13) {
      this.searchRoleFn()
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { isModalVisible, modalTitle, roleColumns, rowData, powerMenuList, tableList, checked } = this.state;
    return (
      <>
        <div className="btnStyle" style={{ marginBottom: "10px" }}>
          <Button onClick={this.handleRoleAdd}>
            <Icon type="plus-circle" />
            添加
          </Button>
          <Button onClick={this.handleRoleEdit}>
            <Icon type="minus-circle" />
            修改
          </Button>
          <Button onClick={this.handleRoleDelete}>
            <Icon type="close-circle" />
            删除
          </Button>
        </div>

        <Form layout="inline" className="searchBox">
          <Form.Item label="角色编码">
            {getFieldDecorator("roleCode")(<Input onChange={this.handleRoleCode} onKeyUp={this.onKeyUpFn} />)}
          </Form.Item>
          <Form.Item label="角色名称">
            {getFieldDecorator("roleName")(<Input onChange={this.handleRoleName} onKeyUp={this.onKeyUpFn} />)}
          </Form.Item>
          <Button onClick={this.searchRoleFn}>查询</Button>
        </Form>

        <Table
          columns={roleColumns}
          dataSource={tableList}
          rowKey={(record) => record.ROLE_UID}
          pagination={{
            total: this.state.RowCount,
            current: this.state.PageNo,
            onChange: this.changePageFn
          }}
          onRow={this.onClickRow}
          rowClassName={this.setRowClassName}
        />
        {isModalVisible ?
          <Modal
            title={
              <div className="patient_title">
                <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                <span>{modalTitle === "ROLE_ADD" ? "添加角色" : "编辑角色"}</span>
              </div>
            }
            visible={isModalVisible}
            maskClosable={false}
            onOk={this.handleRoleSubmit}
            onCancel={this.handleCancel}
          >
            <Form className="settingUserWrap settingComponentWrap checkWrap" layout="inline">
              {modalTitle === 'ROLE_EDIT' ?
                <div className="lineBlock settingHospitalRequire">
                  <Form.Item label="角色编码">
                    {getFieldDecorator('ROLE_CODE', { initialValue: rowData.ROLE_CODE })(<Input disabled />)}
                  </Form.Item>
                </div> : null
              }

              <div className="lineBlock settingHospitalRequire">
                <Form.Item label="角色名称">
                  {getFieldDecorator('ROLE_NAME', { initialValue: rowData.ROLE_NAME, rules: [{ required: true, message: '请输入角色名称' }] })(<Input allowClear={true} />)}
                </Form.Item>
              </div>
              <div className="lineBlock" >
                <Form.Item label="是否有效">
                  {getFieldDecorator("IS_ENABLED", { valuePropName: 'checked', initialValue: modalTitle === 'ROLE_ADD' ? checked : rowData.IS_ENABLED })(
                    <Checkbox onChange={this.onAddCheckbox}>有效</Checkbox>
                  )}
                </Form.Item>
              </div>
              <div className="lineBlock">
                <Form.Item label="描述">
                  {getFieldDecorator('ROLE_REMARKS', { initialValue: rowData.ROLE_REMARKS })(
                    <TextArea rows={4} />
                  )}
                </Form.Item>
              </div>
              <div className="lineBlock">
                <Form.Item label="角色权限" className="roleAudit">
                  {getFieldDecorator("PRIVILEGE", { initialValue: modalTitle === 'ROLE_ADD' ? [] : rowData.PRIVILEGE_UID })(
                    <Checkbox.Group
                      onChange={this.handleRoleValue}
                      options={powerMenuList}
                    >
                    </Checkbox.Group>
                  )}
                </Form.Item>
              </div>
            </Form>
          </Modal> : null
        }

      </>
    );
  }
}

export default Form.create({})(SettingRole);